export default function AgendaItemReportDirective() {
  return {
    template: require('./agendaItem-report.html'),
    scope: {
      agendaItemId: '=',
      canDelete: '=',
      agendaItemReportDetail: '=',
      isInDialog: '='
    },
    controller: 'AgendaItemReportController',
    controllerAs: 'agendaItemReportVM',
    bindToController: true,
    replace: true
  };
}
